var map = {
	"./0_armies.png": 93,
	"./1_armies.png": 94,
	"./2_armies.png": 95,
	"./3_armies.png": 96,
	"./4_armies.png": 97,
	"./5_armies.png": 98,
	"./6_armies.png": 99,
	"./arryn_power.png": 100,
	"./arryn_token.png": 101,
	"./background.png": 102,
	"./baratheon_power.png": 103,
	"./baratheon_token.png": 104,
	"./castles.png": 43,
	"./castles_win.png": 44,
	"./game_round_marker.png": 45,
	"./got.png": 42,
	"./greyjoy_power.png": 105,
	"./greyjoy_token.png": 106,
	"./house_arryn.png": 107,
	"./house_baratheon.png": 108,
	"./house_greyjoy.png": 109,
	"./house_lannister.png": 110,
	"./house_martell.png": 111,
	"./house_stark.png": 112,
	"./house_targaryen.png": 113,
	"./house_tyrell.png": 114,
	"./influence.png": 21,
	"./influence_1stars.png": 46,
	"./influence_2stars.png": 47,
	"./influence_3stars.png": 48,
	"./influence_targaryen.png": 28,
	"./influence_targaryen_3stars.png": 49,
	"./influence_tracks.png": 50,
	"./influence_tracks_expansion.png": 51,
	"./iron_throne_token.png": 115,
	"./lannister_power.png": 116,
	"./lannister_token.png": 117,
	"./martell_power.png": 118,
	"./martell_token.png": 119,
	"./messenger-raven-token.png": 120,
	"./round&victory_tracks.png": 121,
	"./round.png": 52,
	"./stark_power.png": 122,
	"./stark_token.png": 123,
	"./supply_icon.png": 53,
	"./supply_track.png": 124,
	"./targaryen_power.png": 125,
	"./targaryen_token.png": 126,
	"./tyrell_power.png": 127,
	"./tyrell_token.png": 128,
	"./valyrian-steel-blade-token.png": 129,
	"./victory_tracks.png": 54,
	"./wildling.png": 55,
	"./wildlings_track.png": 130
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29;